module.exports = __webpack_public_path__ + "img/DurchDenKiez.bf35f515.jpg";